import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

/**
 * Page Témoignages — POC Phase 5
 * URL : /plateforme/temoignages
 * Page critique pour la conversion : preuve sociale par d'authentiques élèves de l'Institut.
 */
export default function PlateformeTemoignages() {
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    document.title = "Témoignages — Institut Impact Élite";
    const linkPreconn = document.createElement("link");
    linkPreconn.rel = "preconnect";
    linkPreconn.href = "https://fonts.googleapis.com";
    document.head.appendChild(linkPreconn);
    const linkFonts = document.createElement("link");
    linkFonts.rel = "stylesheet";
    linkFonts.href =
      "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700;900&family=Inter:wght@300;400;500;700&display=swap";
    document.head.appendChild(linkFonts);
    return () => {
      document.head.removeChild(linkPreconn);
      document.head.removeChild(linkFonts);
    };
  }, []);

  // Témoignages PLACEHOLDER — à remplacer par de vrais témoignages d'élèves de Ralph
  const TEMOIGNAGES = [
    {
      id: 1,
      name: "Marc T.",
      role: "Membre PCN · 18 mois",
      discipline: "Kickboxing / Muay Thaï",
      quote:
        "Avant l'Institut, j'allais à la gym sans direction. Avec Ralph, chaque cours a un sens. Je vois ma progression chaque semaine. Et ce n'est plus juste physique — c'est mental.",
      result: "−12 kg · ceinture jaune",
    },
    {
      id: 2,
      name: "Sophie L.",
      role: "Membre PCO · 8 mois",
      discipline: "Kickboxing / Muay Thaï",
      quote:
        "Je pensais être trop vieille pour commencer. Ralph m'a montré que la discipline n'a pas d'âge. Aujourd'hui, je comprends ce qu'on appelle « la voie » — et elle change tout.",
      result: "Confiance · constance",
    },
    {
      id: 3,
      name: "Dimitri R.",
      role: "Membre Master Club · 4 ans",
      discipline: "JJ Brésilien",
      quote:
        "Ralph ne pousse pas, il guide. C'est différent. On apprend à se challenger soi-même plutôt qu'à imiter le coach. C'est la vraie marque d'un grand sensei.",
      result: "Ceinture bleue BJJ",
    },
    {
      id: 4,
      name: "Andréane P.",
      role: "Membre PCN · 2 ans",
      discipline: "Kickboxing / Muay Thaï",
      quote:
        "L'Institut m'a appris à frapper, à esquiver, à réfléchir sous pression. Mais surtout, à oser. Au travail, dans ma vie, partout. C'est plus qu'un sport.",
      result: "1er combat amateur · victoire",
    },
    {
      id: 5,
      name: "Jonathan B.",
      role: "Membre Master Club · 6 ans",
      discipline: "JJ Can Ryu",
      quote:
        "Le Jiu-Jitsu Can Ryu de Ralph, c'est de la tradition vivante. Pas du folklore. On apprend à neutraliser sans détruire. C'est aussi puissant qu'humain.",
      result: "Ceinture verte JJ Can Ryu",
    },
    {
      id: 6,
      name: "Mélissa V.",
      role: "Parent · enfant 9 ans",
      discipline: "Petits Samouraïs",
      quote:
        "Mon fils a changé en 6 mois. Il est plus calme à la maison, plus respectueux à l'école. Le programme Petit Samouraï, c'est de l'éducation autant que du sport.",
      result: "Discipline · respect",
    },
  ];

  const FILTERS = [
    { id: "all", label: "Tous" },
    { id: "Kickboxing / Muay Thaï", label: "Kickboxing / Muay Thaï" },
    { id: "JJ Can Ryu", label: "JJ Can Ryu" },
    { id: "JJ Brésilien", label: "JJ Brésilien" },
    { id: "Petits Samouraïs", label: "Enfants" },
  ];

  const filtered = filter === "all" ? TEMOIGNAGES : TEMOIGNAGES.filter((t) => t.discipline === filter);

  const baseStyle = {
    fontFamily: "Inter, system-ui, sans-serif",
    background: "#0d0d0d",
    color: "#f5f5f5",
    minHeight: "100vh",
  };

  return (
    <div style={baseStyle} data-testid="temoignages-page">
      <style>{`
        .editorial { font-family: 'Playfair Display', serif; }
        .label { letter-spacing: 0.4em; font-size: 11px; }
        .frame { border: 1px solid rgba(201, 169, 97, 0.25); }
        .divider-gold { background: linear-gradient(90deg, transparent, #C9A961 30%, #C9A961 70%, transparent); height: 1px; }
        .gold { color: #C9A961; }
        .red-c { color: #C8102E; }
        .bg-red-c { background: #C8102E; }
        .bg-gold { background: #C9A961; }
        .btn-primary { background: #C8102E; color: #fff; transition: 0.3s; }
        .btn-primary:hover { background: #fff; color: #C8102E; }
        .btn-secondary { color: #C9A961; border: 1px solid #C9A961; transition: 0.3s; background: transparent; }
        .btn-secondary:hover { background: #C9A961; color: #0d0d0d; }
        .pf-link { transition: color 0.2s; }
        .pf-link:hover { color: #C9A961; }
        .filter-tab {
          padding: 10px 20px;
          font-size: 11px;
          letter-spacing: 0.2em;
          cursor: pointer;
          transition: all 0.2s;
          border: 1px solid rgba(201, 169, 97, 0.25);
          background: transparent;
          color: rgba(255, 255, 255, 0.6);
        }
        .filter-tab:hover { border-color: #C9A961; color: #C9A961; }
        .filter-tab.active { background: #C9A961; color: #0d0d0d; font-weight: 700; border-color: #C9A961; }
        .testimonial-card { transition: background 0.3s, transform 0.3s; }
        .testimonial-card:hover { background: #1a1a1a; transform: translateY(-4px); }
      `}</style>

      {/* === NAV === */}
      <nav className="px-10 py-6 flex items-center justify-between sticky top-0 z-50 backdrop-blur-md"
        style={{ background: "rgba(0,0,0,0.8)", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
        <Link to="/plateforme" className="flex items-center gap-4">
          <div className="relative">
            <div className="w-12 h-12 bg-red-c flex items-center justify-center">
              <span className="editorial text-white text-2xl font-black">I</span>
            </div>
            <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-gold"></div>
          </div>
          <div>
            <div className="label gold">— INSTITUT —</div>
            <div className="editorial text-2xl font-bold leading-none mt-0.5">Impact Élite</div>
          </div>
        </Link>
        <div className="hidden md:flex gap-6 text-sm items-center">
          <Link to="/plateforme" className="pf-link">← Retour</Link>
          <Link to="/plateforme#tarifs" className="btn-primary px-6 py-2 text-xs tracking-[0.3em] font-bold">DÉBUTER →</Link>
        </div>
      </nav>

      {/* === HERO === */}
      <section className="px-10 py-24" data-testid="temoignages-hero">
        <div className="max-w-6xl mx-auto">
          <div className="label red-c mb-6">VOLUME 03 · CHAPITRE 01</div>
          <h1 className="editorial font-black text-5xl md:text-8xl leading-[0.9] mb-8" data-testid="temoignages-title">
            Ils ont fait <span className="italic gold">le pas</span>.<br />
            Voici ce qu'ils <span className="italic">en disent</span>.
          </h1>
          <div className="divider-gold w-32 mb-10"></div>
          <p className="text-xl text-white/70 max-w-3xl leading-relaxed">
            Pas de fausses promesses. Pas de scénarios marketing. Que des paroles d'élèves réels de l'Institut Impact Élite — Val-d'Or, Québec — qui ont accepté de partager leur parcours.
          </p>
          <div className="mt-16 grid grid-cols-3 gap-8 max-w-2xl">
            <div data-testid="stat-membres">
              <div className="editorial text-5xl font-bold gold">200+</div>
              <div className="label text-white/50 mt-2">MEMBRES FORMÉS</div>
            </div>
            <div data-testid="stat-anciennete">
              <div className="editorial text-5xl font-bold gold">11</div>
              <div className="label text-white/50 mt-2">ANS L'INSTITUT</div>
            </div>
            <div data-testid="stat-retention">
              <div className="editorial text-5xl font-bold gold">94%</div>
              <div className="label text-white/50 mt-2">DE RÉTENTION</div>
            </div>
          </div>
        </div>
      </section>

      {/* === FILTRES === */}
      <section className="px-10 py-8 sticky top-[88px] z-30" style={{ background: "rgba(13,13,13,0.95)", backdropFilter: "blur(8px)", borderTop: "1px solid rgba(201,169,97,0.15)", borderBottom: "1px solid rgba(201,169,97,0.15)" }}>
        <div className="max-w-6xl mx-auto flex flex-wrap gap-3 items-center justify-between">
          <div className="label gold">— FILTRER PAR DISCIPLINE —</div>
          <div className="flex flex-wrap gap-2">
            {FILTERS.map((f) => (
              <button
                key={f.id}
                onClick={() => setFilter(f.id)}
                className={`filter-tab ${filter === f.id ? "active" : ""}`}
                data-testid={`filter-${f.id.replace(/\s/g, "-").toLowerCase()}`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* === GRILLE TÉMOIGNAGES === */}
      <section className="px-10 py-24" data-testid="temoignages-grid">
        <div className="max-w-6xl mx-auto">
          {filtered.length === 0 ? (
            <div className="text-center py-20 text-white/40 italic">
              Aucun témoignage pour cette discipline pour l'instant.
            </div>
          ) : (
            <div className="grid md:grid-cols-2 gap-6">
              {filtered.map((t) => (
                <div key={t.id} className="testimonial-card frame p-10" style={{ background: "#0d0d0d" }} data-testid={`testimonial-${t.id}`}>
                  <div className="flex items-baseline justify-between mb-6">
                    <div className="editorial text-6xl gold" style={{ opacity: 0.5, lineHeight: 0.6 }}>"</div>
                    <div className="label gold">{t.discipline.toUpperCase()}</div>
                  </div>
                  <p className="editorial italic text-xl text-white/90 leading-relaxed mb-8">
                    {t.quote}
                  </p>
                  <div className="divider-gold mb-6 opacity-50"></div>
                  <div className="flex items-end justify-between">
                    <div>
                      <div className="editorial font-bold text-xl">{t.name}</div>
                      <div className="text-xs text-white/50 mt-1">{t.role}</div>
                    </div>
                    <div className="text-right">
                      <div className="label gold">RÉSULTAT</div>
                      <div className="text-xs text-white/70 mt-1">{t.result}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* === CTA === */}
      <section className="px-10 py-24" style={{ background: "#161616" }}>
        <div className="max-w-4xl mx-auto text-center">
          <div className="label red-c mb-6">— TON HISTOIRE —</div>
          <h2 className="editorial font-black text-4xl md:text-6xl mb-6">
            Et toi? <span className="italic gold">Quand commences-tu?</span>
          </h2>
          <p className="text-white/70 max-w-2xl mx-auto mb-12">
            Ces histoires ont commencé par un cours d'essai (19,98 $). Le tien aussi peut commencer aujourd'hui.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/plateforme#tarifs" className="btn-primary px-10 py-4 font-bold tracking-[0.2em] text-xs">
              VOIR LES CYCLES & TARIFS →
            </Link>
            <Link to="/plateforme/fondateur" className="btn-secondary px-10 py-4 font-bold tracking-[0.2em] text-xs">
              EN APPRENDRE PLUS SUR LE FONDATEUR
            </Link>
          </div>
        </div>
      </section>

      {/* === FOOTER === */}
      <footer className="px-10 py-12" style={{ borderTop: "1px solid rgba(201,169,97,0.2)" }}>
        <div className="max-w-6xl mx-auto text-center">
          <div className="editorial font-black text-2xl mb-2">Institut Impact Élite</div>
          <div className="text-sm text-white/60 mb-6">Val-d'Or, Québec, Canada · sdm.rdjp@gmail.com</div>
          <div className="divider-gold w-32 mx-auto mb-4"></div>
          <div className="text-xs text-white/40 tracking-widest">© 2026 — POC PHASE 5 · TÉMOIGNAGES (PLACEHOLDERS)</div>
          <div className="text-[10px] text-white/30 mt-2 max-w-2xl mx-auto">
            ⚠️ Témoignages actuels = placeholders. À remplacer par des citations authentiques validées par les membres réels.
          </div>
        </div>
      </footer>
    </div>
  );
}
